import { Grid, Button, MuiThemeProvider, Tab, Tabs, Tooltip, Icon, ButtonBase } from '@material-ui/core';
import ProductCard from 'components/ProductCard';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import moment from 'moment';
import React, { Fragment } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { showcaseProfile } from 'store/Orbita/Showcase/actions';

import ModalEvaluation from './components/ModalEvaluation/index';
import styles from './styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  classes?: any;
  match?: any;
  data: any;
}

interface IStates {
  isFetching: boolean;
  tabSelected: string;
  openModalEvaluation: boolean;
  producerId: any;
}

class ProducerDetail extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isFetching: true,
      tabSelected: 'produtos',
      openModalEvaluation: false,
      producerId: 0,
    };
  }

  async componentDidMount() {
    const { producerId } = this.props.match.params;
    this.setState({ isFetching: true });
    await this.props.dispatch(showcaseProfile(producerId));
    this.setState({ isFetching: false, producerId });
  }

  handleChangeTab = (tab: string) => {
    this.setState({ tabSelected: tab });
  };

  openModalEvaluation = () => {
    this.setState({ openModalEvaluation: true });
  };

  closeModalEvaluation = () => {
    this.setState({ openModalEvaluation: false });
  };

  render() {
    const { classes, data } = this.props;
    const { isFetching, tabSelected, openModalEvaluation, producerId } = this.state;
    const { badges } = data;

    return (
      <MuiThemeProvider theme={theme}>
        {isFetching && <Spin />}
        {!isFetching && !data && 'Perfil não encontrado'}
        {!isFetching && data && (
          <Fragment>
            <Grid container spacing={2}>
              <Grid item xs={12} md={2}>
                <div className={classes.column}>
                  <img src={data.url_image} className={classes.image} alt='details' />
                  <h1 className={classes.title}>{data.name}</h1>
                  <div className='m16' />
                  <div>
                    <span className={`${classes.starScore} big center`}>
                      <Icon className={classes.star}>star</Icon>
                      <FormattedNumber maximumFractionDigits={1} value={data.stars} />
                    </span>

                    <ButtonBase onClick={this.openModalEvaluation}>Avaliar produtor</ButtonBase>
                  </div>
                  <div className='m16' />

                  {data.chat_with !== 0 && (
                    <Link to={'/producer/messages/' + data.chat_with}>
                      <Button color='secondary' variant='contained'>
                        Iniciar conversa
                      </Button>
                    </Link>
                  )}

                  <div className='m16' />
                  {data.show_contact && data.is_affiliate && (
                    <div className={classes.contactInfo}>
                      {data.phone && (
                        <div>
                          <Icon fontSize='inherit' style={{ marginRight: '0.5rem' }}>
                            phone
                          </Icon>
                          {data.phone}
                        </div>
                      )}
                      {data.email && (
                        <div>
                          <Icon fontSize='inherit' style={{ marginRight: '0.5rem' }}>
                            email
                          </Icon>
                          {data.email}
                        </div>
                      )}
                      {data.skype && (
                        <div>
                          <Icon fontSize='inherit' style={{ marginRight: '0.5rem' }}>
                            video_call
                          </Icon>
                          Skype: {data.skype}
                        </div>
                      )}
                    </div>
                  )}
                  <div className='m16' />
                  {(badges || []).length > 0 && (
                    <>
                      <span className={classes.achievementsTitle}>Conquistas desse produtor</span>
                      <div className={classes.achievements}>
                        {badges.map((badge: any) => (
                          <React.Fragment key={'detailbadgeprd-' + badge.id}>
                            <Tooltip
                              title={
                                <div>
                                  {badge.name}: {badge.hint} <br /> Conquistado em {moment(badge.qualified_at).format('DD/MM/YYYY')}
                                </div>
                              }
                              placement='top'
                            >
                              <div className={classes.achievement}>
                                {badge.has_plus ? (
                                  <img src={`/img/badges/${badge.badge_elite}-plus.svg`} alt={`Badge ${badge.name}`} />
                                ) : (
                                  <img src={`/img/badges/${badge.badge_elite}.svg`} alt={'badgeimg'} />
                                )}
                              </div>
                            </Tooltip>
                          </React.Fragment>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} md={7}>
                <div className={classes.card}>
                  <Tabs
                    variant='scrollable'
                    scrollButtons='on'
                    classes={{
                      root: classes.tabsRoot,
                      indicator: classes.tabsIndicator,
                      scrollButtons: classes.scrollButton,
                    }}
                    value={tabSelected}
                  >
                    <Tab
                      classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                      onClick={() => this.handleChangeTab('produtos')}
                      value={'produtos'}
                      label='Produtos'
                    />
                    <Tab
                      classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                      onClick={() => this.handleChangeTab('afiliacoes')}
                      value={'afiliacoes'}
                      label='Afiliações'
                    />
                  </Tabs>
                  {tabSelected === 'produtos' && (
                    <div className={classes.tabContent}>
                      <Grid container spacing={2}>
                        {data.products?.map((item: any) => (
                          <Grid item xs={12} sm={6} md={4} key={item.id}>
                            <ProductCard data={item} />
                          </Grid>
                        ))}
                      </Grid>
                    </div>
                  )}
                  {tabSelected === 'afiliacoes' && (
                    <div className={classes.tabContent}>
                      <Grid container spacing={2}>
                        {data.affiliations?.map((item: any) => (
                          <Grid key={item.id} item xs={12} sm={6} md={4}>
                            <ProductCard data={item} />
                          </Grid>
                        ))}
                      </Grid>
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div className={classes.card}>
                  <h2 className={classes.cardTitle}>Público-alvo</h2>
                  <div className={classes.cardContent}>
                    {Object.keys(data.target || {}).map((category: any, indexcat: any) => (
                      <div className={classes.target} key={'target-' + indexcat}>
                        <strong>{category}</strong>
                        {data.target[category]?.map((response: any, indexresp: any) => (
                          <span key={'targetresp-' + indexresp}>{response}</span>
                        ))}
                      </div>
                    ))}
                    {Object.keys(data.target || {}).length === 0 && 'Não possui público alvo'}
                  </div>
                </div>
              </Grid>
            </Grid>
            <ModalEvaluation open={openModalEvaluation} producerId={producerId} onClose={this.closeModalEvaluation} />
          </Fragment>
        )}
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    data: state.orbita.Showcase.showcaseProfile,
  };
}

export default connect(mapStateToProps)(styles(ProducerDetail));
